/** Shared reply subset used by web and native: headings, lists, paragraphs and code.
 * ponytail: flat lists match current Baxter web rendering; use a full parser when replies require nested blocks/tables.
 */
export type BaxterBlock =
  | { kind: 'paragraph'; text: string }
  | { kind: 'code'; text: string }
  | { kind: 'heading'; text: string; level: number }
  | { kind: 'ul'; items: string[] }
  | { kind: 'ol'; items: string[] };

export function baxterMarkdownBlocks(source: string): BaxterBlock[] {
  const blocks: BaxterBlock[] = [];
  let list: Extract<BaxterBlock, { items: string[] }> | null = null;
  let fence: string[] | null = null;
  const flushFence = () => { blocks.push({ kind: 'code', text: (fence ?? []).join('\n') }); fence = null; };
  for (const line of source.split('\n')) {
    if (line.startsWith('```')) {
      if (fence) flushFence(); else { list = null; fence = []; }
      continue;
    }
    if (fence) { fence.push(line); continue; }
    const heading = /^(#{1,6})\s+(.*)$/.exec(line);
    if (heading) { list = null; blocks.push({ kind: 'heading', level: Math.min(heading[1].length + 1, 6), text: heading[2] }); continue; }
    const bullet = /^\s*[-*]\s+(.*)$/.exec(line);
    const numbered = /^\s*\d+\.\s+(.*)$/.exec(line);
    if (bullet || numbered) {
      const kind = bullet ? 'ul' : 'ol';
      if (!list || list.kind !== kind) { list = { kind, items: [] }; blocks.push(list!); }
      list!.items.push((bullet ?? numbered)![1]);
      continue;
    }
    if (!line.trim()) continue;
    list = null; blocks.push({ kind: 'paragraph', text: line });
  }
  if (fence) flushFence();
  return blocks;
}
